module.exports = __webpack_public_path__ + "img/studies_rubicon_biatorbagy_02.d4ec94bf.png";